import { isToolUIPart, type UIMessage } from "ai";

export const UNANSWERED_APPROVAL_REASON =
  "Denied automatically because the user sent another message without approving this action.";

/**
 * Close unanswered approvals before the latest user message. Approval-only
 * continuations leave the current turn untouched. The browser can pass the
 * array length immediately before appending a new user message.
 */
export function denyUnansweredToolApprovals<T extends UIMessage>(
  messages: T[],
  beforeMessageIndex = messages.findLastIndex((message) => message.role === "user"),
): T[] {
  return messages.map((message, index) => {
    if (index >= beforeMessageIndex || message.role !== "assistant") return message;
    return {
      ...message,
      parts: message.parts.map((part) => {
        if (!isToolUIPart(part) || part.state !== "approval-requested") return part;
        return {
          ...part,
          state: "output-denied" as const,
          approval: {
            ...part.approval,
            approved: false as const,
            reason: UNANSWERED_APPROVAL_REASON,
          },
        };
      }),
    };
  });
}
